import React from "react";
import PropTypes from "prop-types";

class ConfirmTips extends React.Component {
  render() {
    const { text, className } = this.props;
    return (
      <div
        className={`confirm-tips-container ${className || ""}`}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
}

ConfirmTips.propTypes = {
  text: PropTypes.string,
};

export default ConfirmTips;
